import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { colors, fontFamily } from "../../theme/palette";

type NavItem = {
  label: string;
  path: string;
  icon: ReactNode;
};

const NAV_ITEMS: NavItem[] = [
  { label: "単語", path: "/dictionary", icon: <MenuBookRoundedIcon sx={{ fontSize: 22 }} /> },
  { label: "学習", path: "/quiz", icon: <SchoolRoundedIcon sx={{ fontSize: 22 }} /> },
];

const NAV_ITEMS_RIGHT: NavItem[] = [
  { label: "成績", path: "/quiz/mistakes", icon: <InsightsRoundedIcon sx={{ fontSize: 22 }} /> },
  { label: "設定", path: "/mypage", icon: <SettingsRoundedIcon sx={{ fontSize: 22 }} /> },
];

function NavButton({ item, active, onClick }: { item: NavItem; active: boolean; onClick: () => void }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.4,
        width: 64,
        cursor: "pointer",
        color: active ? colors.accent : colors.textMuted,
      }}
    >
      {item.icon}
      <Typography sx={{ fontSize: "0.6rem", fontWeight: active ? 700 : 500, fontFamily }}>
        {item.label}
      </Typography>
    </Box>
  );
}

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleAdd = () => {
    navigate("/dictionary?add=1");
  };

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        flex: "none",
        padding: "8px 16px calc(10px + env(safe-area-inset-bottom))",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: colors.bgSoft,
        borderTop: `1px solid ${colors.border}`,
      }}
    >
      {NAV_ITEMS.map((item) => (
        <NavButton
          key={item.path}
          item={item}
          active={location.pathname === item.path}
          onClick={() => navigate(item.path)}
        />
      ))}

      <Box
        onClick={handleAdd}
        sx={{
          width: 50,
          height: 50,
          marginTop: "-20px",
          borderRadius: "99px",
          background: colors.accent,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `0 12px 24px -10px rgba(${colors.accentRgb},0.7)`,
          cursor: "pointer",
          "&:hover": { background: colors.accentDark },
        }}
      >
        <AddRoundedIcon sx={{ fontSize: 26 }} />
      </Box>

      {NAV_ITEMS_RIGHT.map((item) => (
        <NavButton
          key={item.path}
          item={item}
          active={location.pathname === item.path}
          onClick={() => navigate(item.path)}
        />
      ))}
    </Box>
  );
}
